import { useEffect } from "react";
import { useAtom } from "jotai";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "semantic-ui-react";
import { userAtom } from "../atoms/authAtom";
import { cartAtom } from "../atoms/cartAtom.js";

const CustomerOrderButton = ({}) => {
  const [cart, setCart] = useAtom(cartAtom);
  const [user] = useAtom(userAtom);

  const { t } = useTranslation();

  if (!user?.admin) return null;

  return (
    <Button
      style={{ marginTop: "1em" }}
      color="red"
      icon
      labelPosition="left"
      size="big"
      as={Link}
      to="/admin/cart-to-order"
      disabled={cart?.items?.length === 0 || cart?.items?.reduce((acc, item) => acc + item.quantity, 0) === 0}
    >
      <Icon name="shopping cart" />
      {t("cart_to_customer_order")}
    </Button>
  );
};

export default CustomerOrderButton;
